import { render, staticRenderFns } from "./move-top-button.vue?vue&type=template&id=076c9ba4&scoped=true&lang=pug&"
import script from "./move-top-button.vue?vue&type=script&lang=js&"
export * from "./move-top-button.vue?vue&type=script&lang=js&"
import style0 from "./move-top-button.vue?vue&type=style&index=0&id=076c9ba4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076c9ba4",
  null
  
)

export default component.exports